var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #192355;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M213.9,233.4s-64.2-63.8-22.8-160.4h0c0,0-73.8,95.2,23.7,181.3h0s-130.1-11.5-92.9-142.2c0,0,21.3-83,122.6-99.1h0s-.6,3.4-1.3,7.7c-1,6.3-1.6,10.3-1.8,16.6h0c-3.2,123.7,9,145.7-27.5,196.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.8,8.5s-2.7,3.8,124.7,15c0,0,31.8-16.7,50.6-21.9H71.7s-12.8,1.9-21.9,6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,78.1l101.6,6.4s5.2-10.5,8.9-13.9c0,0-103.7-13-107.5-18.9,0,0-4.8,9.7-3,26.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17,45.5s10,9.8,111.9,16.4c0,0,11.2-13.7,25.1-23.9,0,0-91.8-11.8-114.1-21-.1,0-17.9,11-22.9,28.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.6,86.5v17.3s81.1,21,87,18c0,0,2.1-19.8,11.4-30.5l-98.4-4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.6,108.6v34.9l82.7,4.1s0-13.7,2.3-18.2c0-.1-72-14.2-85-20.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.6,151l83.2,3.6v20.7s-43.3-3.4-83.2-13.8c0,0,0-10.5,0-10.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.6,163.9s-.6,15,7.1,26c0,0,65.4,6,80.5,6.2,0,0-4.4-11.6-4.4-16.7,0,0-52-4-83.2-15.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24,199.1l78.9,1.5s7.3,15.9,20,26.8c0,0-96.5-11.9-98.9-28.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.3,213.3s10.9,23.7,75.7,18.5c0,0-39.4-6.7-75.7-18.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWps);
export default __webpack_public_path__ + "static/media/wps.973d0314f5d8999daa5041f93fee0ccf.svg";
export { ForwardRef as ReactComponent };